import '../App.css';
import { Flex, HStack, Img, Spacer } from '@chakra-ui/react';
import React from 'react';
import SignInButton from './SignInButton';
import logo from './../Assets/Images/logo.png';
import Nav from './Nav';
import NavBar from './NavBar';

function Header() {
  return (
    <>
      <Flex w="100%" bg="#FBF9F4" h="fit-content" alignItems="center">
        <Img
          src={logo}
          alt="Logo"
          style={{ height: '80px', padding: '15px' }}
        />
        <Spacer />
        <HStack>
          <Nav />
          <SignInButton />
        </HStack>
      </Flex>
    </>
  );
}

export default Header;
